module.exports = {
  schemeActionbar1: require(`./homepage/scheme-actionbar-1.svg`),
  schemeActionbar2: require(`./homepage/scheme-actionbar-2.svg`),
  schemeActionbar3: require(`./homepage/scheme-actionbar-3.svg`)
};
